import { ProjectActionTypes } from './project.types'
import { API_CONSTANTS } from '../../utils/AppConstants'

const INITIAL_STATE = {
    addProjectSuccess: null,
    addProjectError: null,
    addProjectReqStatus: '',
    projectListSuccess: null,
    projectListError: null,
    projectDetailSuccess: null,
    projectDetailError: null,
    updateProjectDetailSuccess: null,
    updateProjectDetailError: null,
    updateProjectDetailReqStatus: '',
    projectAssignEmployeeSuccess: null,
    projectAssignEmployeeError: null,
    projectAssignEmployeeReqStatus: '',
    projectRemoveEmployeeSuccess: null,
    projectRemoveEmployeeError: null,
    projectRemoveEmployeeReqStatus: '',
    requestProjectSuccess: null,
    requestProjectError: null,
    requestProjectReqStatus: '',
    rejectEmployeeProjectRequestSuccess: null,
    rejectEmployeeProjectRequestError: null,
    rejectEmployeeProjectRequestReqStatus: ''
}

const projectReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case ProjectActionTypes.ADD_PROJECT_REQUEST_SUCCESS:
            return {
                ...state,
                addProjectSuccess: action.payload,
                addProjectError: null,
                addProjectReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ProjectActionTypes.ADD_PROJECT_REQUEST_ERROR:
            return {
                ...state,
                addProjectSuccess: null,
                addProjectError: action.payload,
                addProjectReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ProjectActionTypes.ADD_PROJECT_REQUEST_STATUS:
            return {
                ...state,
                addProjectReqStatus: ''
            }
        case ProjectActionTypes.PROJECT_LIST_REQUEST_SUCCESS:
            return {
                ...state,
                projectListSuccess: action.payload,
                projectListError: null
            }
        case ProjectActionTypes.PROJECT_LIST_REQUEST_ERROR:
            return {
                ...state,
                projectListSuccess: null,
                projectListError: action.payload
            }
        case ProjectActionTypes.PROJECT_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                projectDetailSuccess: action.payload,
                projectDetailError: null
            }
        case ProjectActionTypes.PROJECT_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                projectDetailSuccess: null,
                projectDetailError: action.payload
            }
        case ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST_SUCCESS:
            return {
                ...state,
                updateProjectDetailSuccess: action.payload,
                updateProjectDetailError: null,
                updateProjectDetailReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST_ERROR:
            return {
                ...state,
                updateProjectDetailSuccess: null,
                updateProjectDetailError: action.payload,
                updateProjectDetailReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ProjectActionTypes.PROJECT_UPATE_DETAIL_REQUEST_STATUS:
            return {
                ...state,
                updateProjectDetailReqStatus: ''
            }
        case ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST_SUCCESS:
            return {
                ...state,
                projectAssignEmployeeSuccess: action.payload,
                projectAssignEmployeeError: null,
                projectAssignEmployeeReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST_ERROR:
            return {
                ...state,
                projectAssignEmployeeSuccess: null,
                projectAssignEmployeeError: action.payload,
                projectAssignEmployeeReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ProjectActionTypes.PROJECT_ASSIGN_EMPLOYEE_REQUEST_STATUS:
            return {
                ...state,
                projectAssignEmployeeReqStatus: ''
            }
        case ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST_SUCCESS:
            return {
                ...state,
                projectRemoveEmployeeSuccess: action.payload,
                projectRemoveEmployeeError: null,
                projectRemoveEmployeeReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST_ERROR:
            return {
                ...state,
                projectRemoveEmployeeSuccess: null,
                projectRemoveEmployeeError: action.payload,
                projectRemoveEmployeeReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ProjectActionTypes.PROJECT_REMOVE_EMPLOYEE_REQUEST_STATUS:
            return {
                ...state,
                projectRemoveEmployeeReqStatus: ''
            }
        case ProjectActionTypes.REQUEST_PROJECT_REQUEST_SUCCESS:
            return {
                ...state,
                requestProjectSuccess: action.payload,
                requestProjectError: null,
                requestProjectReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ProjectActionTypes.REQUEST_PROJECT_REQUEST_ERROR:
            return {
                ...state,
                requestProjectSuccess: null,
                requestProjectError: action.payload,
                requestProjectReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ProjectActionTypes.REQUEST_PROJECT_REQUEST_STATUS:
            return {
                ...state,
                requestProjectReqStatus: ''
            }
        case ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST_SUCCESS:
            return {
                ...state,
                rejectEmployeeProjectRequestSuccess: action.payload,
                rejectEmployeeProjectRequestError: null,
                rejectEmployeeProjectRequestReqStatus: API_CONSTANTS.SUCCESS_STATUS
            }
        case ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST_ERROR:
            return {
                ...state,
                rejectEmployeeProjectRequestSuccess: null,
                rejectEmployeeProjectRequestError: action.payload,
                rejectEmployeeProjectRequestReqStatus: API_CONSTANTS.ERROR_STATUS
            }
        case ProjectActionTypes.REJECT_EMPLOYEE_PROJECT_REQUEST_STATUS:
            return {
                ...state,
                rejectEmployeeProjectRequestReqStatus: ''
            }
        case ProjectActionTypes.LOGOUT:
            return INITIAL_STATE
        default:
            return state
    }
}

export default projectReducer